import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { UserContextService, UtilityManagementPermissions } from '../../../../common';


@Component({
  selector: 'app-shared-files-dialog',
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    CommonModule
  ],
  templateUrl: './shared-files-dialog.component.html',
  styleUrl: './shared-files-dialog.component.scss'
})
export default class SharedFilesDialogComponent {
  title = 'Attachments';
  @Input() files: { name: string, size: string, downloadUrl?: string }[] = [];
  @Input() visible: boolean = false;
  @Output() closeDialog = new EventEmitter<void>();
  @Output() downloadAll = new EventEmitter<void>();
  @Output() singleDownload = new EventEmitter<{ name: string, size: string, downloadUrl?: string }>();

  hasReadAttachmentsPermission: boolean = (UserContextService && UtilityManagementPermissions) ? UserContextService.hasPermission(UtilityManagementPermissions?.Attachments?.Read) : false;


  close() {
    this.closeDialog.emit();
    this.visible = false;
  }

  downloadAllFiles() {
    this.downloadAll.emit();
  }

  singleFileDownload(file: { name: string, size: string, downloadUrl?: string }) {
    this.singleDownload.emit(file);
  }
}
